// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

/**
 * @description Widget types retrieved successfully
 */
export const getSharedReportWidgetTypes200Schema = z.unknown();

export const getSharedReportWidgetTypesQueryResponseSchema = z.lazy(() => getSharedReportWidgetTypes200Schema);
